import React from 'react';
import './App.css';
import Header from './Header';
import League from './views/league/League'
import Team from './views/team/Team'
import Article from './views/article/Article';
import Rumor from './views/Rumor.js/Rumor';
import News from './views/News/News';
import Archive from './views/archive/Archive';
import TradeArchive from './views/archive/TradeArchive';
import SuperlativesArchive from './views/archive/SuperlativesArchive';
import TradeTree from './views/archive/TradeTree';
import Admin from './views/admin/Admin';
import UDFA from './views/udfa/UDFA';
import Footer from './Footer';
import { BrowserRouter as Router, Route, Routes, Navigate, useParams } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useAuth } from './hooks/useAuth';

const AdminRoute = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading) return null;
    if (!user?.admin) return <Navigate to="/" replace />;
    return children;
};

const TeamOwnerRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const { teamId } = useParams();
    if (loading) return null;
    if (!user?.team_owner) return <Navigate to="/" replace />;
    if (user.team_id !== parseInt(teamId, 10)) return <Navigate to="/" replace />;
    return children;
};


function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <AuthProvider>
      <Router>
        <div className="App">
          <Header />
          <div className="app-content">
            <Routes>
              <Route exact path="/" element={<League />} />
              <Route path="/teams/:teamId" element={<Team />} />
              <Route path="/articles/:articleId" element={<Article />} />
              <Route path="/news" element={<News />} />
              <Route path="/rumors" element={<Rumor />} />
              <Route path="/archive/trades/:transactionId" element={<TradeTree />} />
              <Route path="/archive/trades" element={<TradeArchive />} />
              <Route path="/archive/superlatives" element={<SuperlativesArchive />} />
              <Route path="/archive" element={<Archive />} />
              <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
              <Route path="/udfa/:teamId" element={<TeamOwnerRoute><UDFA /></TeamOwnerRoute>} />
            </Routes>
          </div>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
